import React from "react";
import { useTranslation } from "react-i18next";
import FooterSection from "../../../components/sections/FooterSection";
import ParallaxCallSection from "../../../components/sections/ParallaxCallSection";

/**
 * Article about the SEZ - Special Economic Zones in Kazakhstan
 * @param {*} props 
 * @returns 
 */
function SpecialZonesInfoPage(props) {

    var { t } = useTranslation();

    return (
        <>
        <ParallaxCallSection 
            URL="https://s0.rbk.ru/rbcplus_pics/media/img/9/29/805511622766299.png"
            headline="Special Economic Zones (SEZ) in Kazakhstan"
            callToAction="Learn more"
        />
        <div className="uk-container uk-margin-large-bottom">
            <div className="uk-section uk-section-default uk-padding">
                <div className="uk-container">

                    <p className="uk-text-lead">
                        Special economic zones (SEZ) in Kazakhstan are created with the aim of accelerated development of regions, improving the integration of the country's economy into global economic processes, creating highly efficient, including high-tech and competitive industries. They are aimed at developing new types of products, attracting investments, improving legal norms of market relations, introducing modern management and economic methods, as well as increasing the tourism capacity of the region and developing tourism infrastructure capable of satisfying the needs of both Kazakhstani and foreign tourists. In addition, SEZs solve social problems by creating jobs and improving the quality of life in the regions.
                    </p>

                    <hr className="uk-divider-icon" />

                    <h2 className="uk-heading-line"><span>Definition</span></h2>
                    <p>
                        The SEZ is a part of the territory of the Republic of Kazakhstan, where a special legal regime is in effect, providing the necessary conditions for conducting activities in priority sectors.
                    </p>

                    <hr className="uk-divider-icon" />

                    <h2 className="uk-heading-line"><span>Current Status</span></h2>
                    <p>
                        Today, there are 14 SEZs operating in Kazakhstan, each of which is focused on a specific industry. The zones began their activities in 2002. Within the framework of these SEZs, 372 projects were implemented, which allowed the creation of more than 27 thousand permanent jobs.
                    </p>

                    <hr className="uk-divider-icon" />

                    <h2 className="uk-heading-line"><span>Benefits for Participants</span></h2>
                    <ul className="uk-list uk-list-bullet uk-margin-bottom">
                        <li>Exempt from corporate, land and property taxes;</li>
                        <li>The VAT rate on goods sold in the territory of the SEZ is 0%;</li>
                        <li>Free provision of land plots for the entire period of the SEZ with the provision of all necessary infrastructure;</li>
                        <li>Exemption from rent and land tax.</li>
                    </ul>

                    <hr className="uk-divider-icon" />

                    <h2 className="uk-heading-line"><span>Coordination</span></h2>
                    <p>
                        JSC "Kazakhstan Center of Industry and Export "QazIndustry" is a coordinator of SEZ in Kazakhstan. The main tasks of the center are to develop, promote and increase the investment attractiveness of special economic and industrial zones, as well as support businesses operating in these territories.
                    </p>
                </div>
            </div>
        </div>
        <FooterSection />
        </>
    );
}

export default SpecialZonesInfoPage;